module.exports = __webpack_public_path__ + "img/logo-f.5cecdaa0.png";